export default __webpack_public_path__ + "static/media/inProgress.d69195db.svg";